// extracted by mini-css-extract-plugin
module.exports = {"searchRemoveButton":"Navigation_searchRemoveButton__1aLTz"};